import News from "../components/News";
import Fleet from "../components/Fleet";
import FormAtHome from "../components/FormAtHome";
import WhyChooseUS from "../components/WhyChooseUs";
import HeroSection from "../components/HeroSection";
import CustomerReviews from "../components/CustomerReviews";
import FamousDestination from "../components/FamousDestination";
import EasyBookingProcess from "../components/EasyBookingProcess";
import { useEffect } from "react";
import About from "../components/About";
import Promo from "../components/Promo";
import Promotions from "../components/Promotions";

function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
    <div>
      <HeroSection />
      <Promotions/>
      <EasyBookingProcess />
      <News />
      <Fleet />
      <WhyChooseUS />
      <FamousDestination />
      <About/>
      {/* <CustomerReviews /> */}
    </div>
  );
}

export default HomePage;
